import React from "react";
import {Route, Redirect} from "react-router-dom";

export default (props) => {

    const renderMergedProps = (component, ...rest) => {
        const finalProps = Object.assign({}, ...rest);
        return (
            React.createElement(component, finalProps)
        );
    }

   /* const PropsRoute = ({ component, ...rest }) => {
        return (
            <Route {...rest} render={routeProps => {
                return renderMergedProps(component, routeProps, rest);
            }}/>
        );
    }*/

    const {component: C, isAuthenticated, ...rest} = props;
   // console.log('===> isAuthenticated', props);

     // Auth state is still loading (null), wait before deciding, needed this to prevent immediate redirect to login if authenticated is null
     if(isAuthenticated === null) {
       return null;
     }

     if(!isAuthenticated) {

      // In React Native WebView without auth, close the modal instead of redirecting
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({ type: "CLOSE_MODAL" }));
        return null;
      }

       const emailParam = sessionStorage.getItem('email_for_redirect') ? `&email=${sessionStorage.getItem('email_for_redirect')}` : ''

        if (emailParam) {
          setTimeout(() => {
            sessionStorage.removeItem('email_for_redirect')
          }, 1000)
        }

        window.location.href = `${
            window.location.origin === "http://radical.local"
              ? "http://radical.local:8080" : ''}`+"/?login=" + window.location.pathname + (window.location.search ? "&" + window.location.search.substr(1) : '') + emailParam
         return null;
     }

    return (
        <Route
            {...rest}
            render={ routeProps  =>
                    renderMergedProps(C, routeProps, rest)
            }
            />

    )
}

